/* PSI Google reviews v2 (25 Oct 2026): read-more in place, show-more, photo viewer. No auto-motion, no outbound links. */
(function () {
  function init(sec) {
    if (sec.__gr) return; sec.__gr = true;
    sec.querySelectorAll('[data-gr-txt]').forEach(function (p) {
      p.classList.add('is-clamped');
      if (p.scrollHeight > p.clientHeight + 4) {
        var b = p.parentNode.querySelector('[data-gr-more]'); b.hidden = false;
        b.addEventListener('click', function () {
          var open = p.classList.toggle('is-clamped') === false;
          b.textContent = open ? 'Show less' : 'Read more';
        });
      } else p.classList.remove('is-clamped');
    });
    var more = sec.querySelector('[data-gr-showmore]'), grid = sec.querySelector('[data-gr-grid]');
    if (window.matchMedia && matchMedia('(max-width: 749px)').matches && grid) {
      var n = 0; grid.dataset.per = 3;
      grid.querySelectorAll('.psi-gr__card:not(.psi-gr__card--feat)').forEach(function (c) { n++; if (n > 3 && !c.hidden) { c.hidden = true; c.setAttribute('data-more', ''); } });
      if (!more && n > 3) { more = document.createElement('button'); more.type = 'button'; more.className = 'psi-gr__btn psi-gr__btn--ghost'; more.setAttribute('data-gr-showmore', ''); more.textContent = 'Show more reviews'; sec.querySelector('.psi-gr__actions').prepend(more); }
    }
    if (more) more.addEventListener('click', function () {
      var per = +grid.dataset.per || 6, hidden = grid.querySelectorAll('[data-more][hidden]');
      for (var i = 0; i < Math.min(per, hidden.length); i++) {
        hidden[i].hidden = false;
        var p = hidden[i].querySelector('[data-gr-txt]');
        if (p && p.scrollHeight > p.clientHeight + 4) hidden[i].querySelector('[data-gr-more]').hidden = false;
      }
      if (grid.querySelectorAll('[data-more][hidden]').length === 0) more.remove();
      try { window.clarity && window.clarity('event', 'psi_greview_more'); } catch (e) {}
    });
    var dlg = sec.querySelector('[data-gr-dlg]'), body = sec.querySelector('[data-gr-body]');
    sec.addEventListener('click', function (e) {
      var p = e.target.closest('[data-gr-photo]');
      if (p) {
        var img = document.createElement('img'); img.className = 'psi-gr__photo'; img.alt = 'Photo from a Google review';
        img.referrerPolicy = 'no-referrer'; img.src = p.getAttribute('data-gr-photo');
        body.innerHTML = ''; body.appendChild(img);
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      } else if (e.target.closest('[data-gr-close]') || e.target === dlg) { dlg.close ? dlg.close() : dlg.removeAttribute('open'); }
    });
  }
  function boot() { document.querySelectorAll('[data-psi-gr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
